import {
    ReactElement,
    HTMLAttributes
} from "react";
import { FilterIcon } from "../../assets";
import { Button } from "./button";
import { useNavigate } from "react-router-dom";
import routes from "../../core/routes";

interface Props extends HTMLAttributes<HTMLElement> {
    str: string;
    search?: any;
    myStyle?: string;
    placeholder?: string;
    onClick?: any;
    isTicket?: boolean;
    hasFilter?: boolean;
    filtered?: boolean;
    buttonTitle: string;
    isCommission?: boolean;
    duration?: string;
    totalFeeNumber?: number;
    startDate?:string;
    endDate?:string;
    showSubmitReq?:boolean;
    loadingContent?:boolean;
    resetFilter?:any;
}

export function FilterInput({ myStyle, onClick, placeholder, showSubmitReq , buttonTitle, filtered,resetFilter,hasFilter, isCommission, duration, totalFeeNumber , startDate,endDate , loadingContent }: Props): ReactElement {
  const navigation = useNavigate();
    return (
        <div className={`filter-input ${myStyle && myStyle}`}>


{loadingContent ? <div className="w-100 search-content-loading content-loading"></div> :
            <>
            <FilterIcon myStyle="filter-icon hide-mobile" color="#000000" />
            <div className="filter-div">

                {isCommission ? <div className="total-fee">


                    <span className="title"> 
                    مجموع کارمزد 

                  ( {duration}  {" "}   از  {" "}   {startDate} تا {endDate} )   {" "}
                    {" "}  
                    </span>

                    <span className="number">
                    {" "}  {totalFeeNumber} <span className="title"> {" "}
                       ریال
                    </span>
                    </span>
                </div> : <span className="title">{placeholder}</span>}
            </div>
            {filtered &&
                <div className="filter-input-filtered">
                    <FilterIcon />
                </div>
            }
             
            {hasFilter &&
                <Button onClick={(()=>resetFilter())} title="حذف فیلتر" myStyle="add-new" />
            }

            {showSubmitReq && 
                <Button onClick={(()=>navigation(`${routes.UNDERCONSTRUCTION}`))} title="ثبت درخواست" myStyle="add-new hide-desktop" />
            }
            <Button onClick={onClick} title={buttonTitle} myStyle="filter-btn hide-mobile" />
            <Button onClick={onClick} title={<FilterIcon color="#ffffff" />} myStyle="filter-btn hide-desktop" />
            </>
}
        </div>
    )
}

export default FilterInput;